export function base64ToFile(base64String: string, fileName: string): File {
    const byteString = atob(base64String);
    const byteNumbers = new Array(byteString.length);
    for (let i = 0; i < byteString.length; i++) {
        const codePoint = byteString.codePointAt(i) ?? 0;
        byteNumbers[i] = codePoint;
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new File([byteArray], fileName);
}

export type CapKeysContainer = {
    capKeysIptFile?: File | string | boolean | null;
    capKeysOptFile?: File | string | boolean | null;
};

export function appendCapKeysToFormData(formData: FormData, data: CapKeysContainer): void {
    if (data.capKeysIptFile) {
        if (data.capKeysIptFile instanceof File) {
            formData.append("capKeysIptFile", data.capKeysIptFile);
        } else if (data.capKeysIptFile && data.capKeysIptFile !== true) {
            const newFileIpt = base64ToFile(data.capKeysIptFile as unknown as string, "capKeysIptFile.txt");
            formData.append("capKeysIptFile", newFileIpt);
        }
    }
    if (data.capKeysOptFile) {
        if (data.capKeysOptFile instanceof File) {
            formData.append("capKeysOptFile", data.capKeysOptFile);
        } else if (data.capKeysOptFile && data.capKeysOptFile !== true) {
            const newFileOpt = base64ToFile(data.capKeysOptFile as unknown as string, "capKeysOptFile.txt");
            formData.append("capKeysOptFile", newFileOpt);
        }
    }
}
